import { Editor, Transforms } from "slate";
import { ListsEditor } from "@prezly/slate-lists";
import { IS_MAC } from "../../utilities/is-mac";
import { insertLineBreak, setTextAlign, toggleFormat } from "./utilities/index";
export const useKeyboardEvents = (props) => {
    const { editor, toolbarRef } = props;
    const handleEditorKeyDown = (e) => {
        const modKey = IS_MAC ? e.metaKey : e.ctrlKey;
        switch (e.key) {
            // Throw focus back to toolbar
            case "F10":
                if (e.altKey) {
                    e.preventDefault();
                    e.stopPropagation();
                    toolbarRef.current?.querySelector(`[tabindex="0"`)?.focus();
                }
                break;
            // Smart backspace behavior within nested lists
            case "Backspace":
                if (!ListsEditor.canDeleteBackward(editor)) {
                    e.preventDefault();
                    ListsEditor.decreaseDepth(editor);
                }
                break;
            case "]":
                if (modKey) {
                    e.preventDefault();
                    ListsEditor.increaseDepth(editor);
                }
                break;
            case "[":
                if (modKey) {
                    e.preventDefault();
                    ListsEditor.decreaseDepth(editor);
                }
                break;
            // Line break behavior
            case "Enter":
                // TODO: Do something better (manage isActive state better)
                e.stopPropagation();
                if (e.shiftKey) {
                    e.preventDefault();
                    insertLineBreak(editor);
                }
                if (ListsEditor.isCursorInEmptyListItem(editor)) {
                    e.preventDefault();
                    ListsEditor.decreaseDepth(editor);
                }
                break;
            // Bold
            case "b":
                if (modKey) {
                    e.preventDefault();
                    toggleFormat(editor, "bold");
                }
                break;
            // Underline
            case "u":
                if (modKey) {
                    e.preventDefault();
                    toggleFormat(editor, "underline");
                }
                break;
            // Italicize
            case "i":
                if (modKey) {
                    e.preventDefault();
                    toggleFormat(editor, "italic");
                }
                break;
            // Toggle ordered List
            case "7":
            case "&":
                if (modKey && e.shiftKey) {
                    toggleFormat(editor, "orderedList");
                }
                break;
            // Toggle unordered List
            case "8":
            case "*":
                if (modKey && e.shiftKey) {
                    toggleFormat(editor, "unorderedList");
                }
                break;
            // text align left
            case "l":
                if (e.shiftKey) {
                    setTextAlign(editor, "left");
                }
                break;
            // text align center
            case "e":
                if (e.shiftKey) {
                    setTextAlign(editor, "center");
                }
                break;
            // text align right
            case "r":
                if (e.shiftKey) {
                    // TODO figure out why this isn't working
                    e.preventDefault();
                    setTextAlign(editor, "right");
                }
                break;
            default:
                break;
        }
    };
    const handleEditorFocus = () => {
        if (!editor.selection) {
            Transforms.select(editor, {
                anchor: Editor.start(editor, []),
                focus: Editor.start(editor, [])
            });
        }
    };
    return { handleEditorFocus, handleEditorKeyDown };
};
